import React from "react";
import { string, node } from "prop-types";

import "./breadcrumb-item.m.css";

const BreadcrumbItem = ({ href, children, ...props }) => {
  if (href) {
    return (
      <a href={href} styleName="breadcrumb-link" {...props}>
        {children}
      </a>
    );
  }

  return (
    <span styleName="breadcrumb-text" {...props}>
      {children}
    </span>
  );
};

BreadcrumbItem.propTypes = {
  href: string,
  children: node.isRequired
};

export default BreadcrumbItem;